function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.787 16.75a4.072 4.072 0 0 1-1.236-2.962 4.12 4.12 0 0 1 1.236-3.012 4.2 4.2 0 0 1 5.967 0A4.1 4.1 0 0 1 18 13.787 4.264 4.264 0 0 1 13.764 18a4.035 4.035 0 0 1-2.977-1.25zm.989-3.255a.654.654 0 0 0 0 .946l.989.991a.483.483 0 0 0 .358.158.5.5 0 0 0 .362-.158l2.292-2.253a.684.684 0 1 0-.966-.969l-1.685 1.667-.382-.383a.677.677 0 0 0-.966 0zM1.348 16.22a1.3 1.3 0 0 1-.952-.4 1.3 1.3 0 0 1-.4-.955V1.352A1.3 1.3 0 0 1 .4.4a1.3 1.3 0 0 1 .948-.4h13.483a1.3 1.3 0 0 1 .952.4 1.3 1.3 0 0 1 .4.955v7.408a3.489 3.489 0 0 0-.663-.293 6.168 6.168 0 0 0-.685-.18V1.352H1.348v13.517h6.944q.09.36.2.7a4.649 4.649 0 0 0 .269.649zm2.921-3.6a.656.656 0 0 1-.48-.191.648.648 0 0 1-.194-.48.661.661 0 0 1 .194-.484.65.65 0 0 1 .48-.2h4.562a3.629 3.629 0 0 0-.292.653q-.112.338-.211.7zm0-3.83a.656.656 0 0 1-.48-.191.648.648 0 0 1-.194-.48.661.661 0 0 1 .194-.484.65.65 0 0 1 .48-.2h7.64a.692.692 0 0 1 .674.676v.225q-.36.09-.652.191a5.063 5.063 0 0 0-.607.259zm0-3.83a.656.656 0 0 1-.48-.191.647.647 0 0 1-.194-.48.661.661 0 0 1 .194-.489.65.65 0 0 1 .48-.2h7.64a.656.656 0 0 1 .48.191.648.648 0 0 1 .194.48.661.661 0 0 1-.194.484.65.65 0 0 1-.48.2z",
    transform: "translate(3 3)",
    style: {
      fill: "#758091"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.4e6f210e79fd982dfc7affc89fc3d3af.svg";
export { ForwardRef as ReactComponent };